import { Spinner } from "@shapr3d/frontend-lib";

import ProgressiveProfiling from "../components/ProgressiveProfiling/ProgressiveProfiling";
import useAccount from "../hooks/useAccount";

const ProgressiveProfilingContainer = () => {
  const { data: accountData } = useAccount();

  if (!accountData) {
    return (
      <div
        style={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }

  return <ProgressiveProfiling />;
};

export default ProgressiveProfilingContainer;
